import { Button, Modal, Alert } from 'react-bootstrap';
import React from "react";
import { Field, reduxForm } from 'redux-form';
import moment from 'moment';

import 'react-widgets/dist/css/react-widgets.css';

import { TextAreaField, ReadonlyInput, DropdownListField } from '../common/Inputs';

import callbackStates from '../../constants/callbackStates';
import * as fetchingState from '../../constants/fetchingState';

let Edit = class extends React.Component {
    constructor(props) {
        super(props);
        this._handleSubmit = this._handleSubmit.bind(this);
        this.state = { callbackStates: callbackStates };
    }
    _handleSubmit(values) {
        const { onSubmit, initialValues: { State } } = this.props;

        if (values['State'] !== State) //in case, state changed
            values['State'] = values['State']['Id'];

        onSubmit(values);
    }

    render() {
        const { onClose, handleSubmit, fetching: updateFetching, crudError, initialValues: callbackEnquiry } = this.props;
        const { callbackStates } = this.state;
        const formVisible = updateFetching === fetchingState.INITIAL;
        const closeButtonVisible = updateFetching === fetchingState.FETCHED || updateFetching === fetchingState.FAILED;
        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>Редактирование заявки</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formVisible && <form className='form-horizontal' onSubmit={handleSubmit(this._handleSubmit)}>
                        <ReadonlyInput value={callbackEnquiry.Id} label="Id" />
                        <ReadonlyInput value={callbackEnquiry.Phone} label="Телефон" />
                        <ReadonlyInput value={moment(callbackEnquiry.CreatedAt).local().format('DD.MM.YYYY HH:mm:ss')} label="Создана" />
                        <Field name='State' component={DropdownListField} data={callbackStates}
                            valueField='Id' textField='Name' label='Статус' />

                        <Field name="Comment" component={TextAreaField}
                            label="Комментарий" />
                    </form>}
                    {updateFetching === fetchingState.FETCHING &&
                        <Alert bsStyle='info'>Пожалуйста, подождите...</Alert>}
                    {updateFetching === fetchingState.FETCHED &&
                        <Alert bsStyle='success'>УСПЕХ!</Alert>}
                    {updateFetching === fetchingState.FAILED &&
                        <Alert bsStyle='danger'>
                            <p>ОШИБКА!</p>
                            {crudError && <p>{crudError}</p>}
                        </Alert>}
                </Modal.Body>
                {formVisible && <Modal.Footer>
                    <Button bsStyle="success" type="submit" onClick={handleSubmit(this._handleSubmit)}>Сохранить</Button>
                    <Button type="button" onClick={onClose}>Отмена</Button>
                </Modal.Footer>}
                {closeButtonVisible &&
                    <Modal.Footer>
                        <Button type="button" onClick={onClose}>
                            Закрыть
                        </Button>
                    </Modal.Footer>}
            </Modal>
        );
    }
}

Edit = reduxForm({
    form: 'callbackEnquiryEdit'
})(Edit);

export default Edit;


// WEBPACK FOOTER //
// ./src/components/callback/Edit.jsx